import React from 'react';
import { render } from '@testing-library/react';
import { Collapsible } from './Collapsible';
import { Card } from '../Card';

describe('Collapsible', () => {
	beforeEach(() => jest.spyOn(console, 'error'));

	it('should pass through data automation attributes', () => {
		const { container } = render(
			<Collapsible data-auto-sel="automation-selector">
				<Card>Lorem ipsum dolor sit amet</Card>
			</Collapsible>
		);

		const element = container.querySelector(
			'[data-auto-sel="automation-selector"]'
		);

		expect(element).not.toBeNull();
	});
});
